import CreerAdministrator from './administrators/creer/page';
import FormAdministrator from './administrators/form';
import ImporterAdministrator from './administrators/importer/page';
import ModifierAdministrator from './administrators/modifier/page';
import AdministratorsPage from './administrators/page';
import Callback from './callback/page';
import CreerEmploye from './employees/creer/page';
import FormEmploye from './employees/form';
import ImporterEmploye from './employees/importer/page';
import ModifierEmploye from './employees/modifier/page';
import EmployeesPage from './employees/page';
import Layout from './layout';
import Login from './login/page';
import Logout from './logout/page';
import Menu from './menu/page';
import CreerNumeroAgrement from './numero-agrement/creer/page';
import ImporterNumeroAgrement from './numero-agrement/importer/page';
import ModifierNumeroAgrement from './numero-agrement/modifier/page';
import NumeroAgrementPage from './numero-agrement/page';
import ResultatsNumeroAgrement from './numero-agrement/resultats/page';
import Recap from './recap/page';
import ResetPassword from './resetPwd/page';
import CreerSociete from './societe/creer/page';
import ModifierSociete from './societe/modifier/page';
import SocietePage from './societe/page';

const NumeroAgrement = {
  NumeroAgrement: NumeroAgrementPage,
  Creer: CreerNumeroAgrement,
  Importer: ImporterNumeroAgrement,
  Modifier: ModifierNumeroAgrement,
  Resultats: ResultatsNumeroAgrement,
};

const Employees = {
  Employees: EmployeesPage,
  Creer: CreerEmploye,
  Importer: ImporterEmploye,
  Modifier: ModifierEmploye,
  Form: FormEmploye,
};

const Administrators = {
  Administrators: AdministratorsPage,
  Creer: CreerAdministrator,
  Importer: ImporterAdministrator,
  Modifier: ModifierAdministrator,
  Form: FormAdministrator,
};

const Societe = {
  Societe: SocietePage,
  Creer: CreerSociete,
  Modifier: ModifierSociete,
};

export {
  Administrators,
  Callback,
  CreerNumeroAgrement,
  Employees,
  ImporterNumeroAgrement,
  Layout,
  Login,
  Logout,
  Menu,
  ModifierNumeroAgrement,
  NumeroAgrement,
  Recap,
  ResetPassword,
  ResultatsNumeroAgrement,
  Societe,
};
